import React from 'react';
import { connect } from 'react-redux';
import Ax from '../../../components/hoc/Ax';
import Loader from '../../../components/ui/Loader/Loader';
import HttpAPICall from '../../../services/HttpAPICall';
import { INVENTORY_API_BASE_URL_2, IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import Status from '../../../components/ui/Status';
import { Modal } from 'bootstrap';
import ItemViewInList from '../includes/ItemViewInList';
import AppBaseComponent from '../../../components/AppBaseComponent';
import uuid from 'react-uuid';
import DateService from '../../../services/DateService';
import tapIcon from '../../../services/TapIcon';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import swal from "sweetalert";
import TapSelect from '../../../components/ui/TapSelect';
import download from '../../../services/DownloadFile';
import TapInputNumber from '../../../components/ui/TapInputNumber';
import ItemDetailsModal from '../../items/itemDetails/ItemDetailsModal';
import POHistoryModal from '../purchaseOrder/POHistoryModal';
import ReqHistoryItemWiseModal from '../requisition/ReqHistoryItemWiseModal';
import PurchaseItemWiseModal from '../purchase/PurchaseItemWiseModal';
import TransferItemWiseListModal from '../inventoryTransfer/TransferItemWiseListModal';
import ConsumptionHistoryModal from '../consumption/ConsumptionHistoryModal';
import ItemTransactionLedger from '../includes/ItemTransactionLedger';
import HistoryDataModal from '../HistoryDataModal';
import WarehouseIndentDocument from './WarehouseIndentDocument';

class IndentDetailModal extends AppBaseComponent {

    constructor(props) {
        super(props);
        
        this.updateCommentFormInit = {
            status: '',
            notes: '',
        }

        this.cancelItemFormInit = {
            notes: '',
        }

        this.state = {
            indent_loading: false,
            indentDetail: null,
            indentTransId: null,
            allAllowedStatus: [],
            addCommentForm: { ...this.updateCommentFormInit },
            addCommentFormSubmitting: false,
            pdfDownloading: false,
            indentAnalysisDownloading: false,
            cancelledItemList: [],
            cancelItemFormSubmitting: false,
            cancelledItemForm: { ...this.cancelItemFormInit },
            cancel_item_loading: false,
            interchangeItemData: null,
            interchangeableItemList: [],
            interchangeableListingMeta: null,
            interchangeableTotalListingCount: 0,
            interchangeable_loading: false,
            interchangeable_page: 1,
            saveInterchangeableItemForm: false,
            interchangeItemForm: { notes: '' },
            remarkItem: null,
            remarkSubmitting: false,
            _loadingTransactionId: null,
        };

        // Refs
        this.itemDetailsRef = React.createRef();
        this.itemWisePORef = React.createRef();
        this.itemWiseReqRef = React.createRef();
        this.itemWisePurchaseRef = React.createRef();
        this.itemWiseTransferRef = React.createRef();
        this.consumptionHistoryRef = React.createRef();
        this.transactionLedgerRef = React.createRef();
        this.HistoryRef = React.createRef();
        this.commentRef = React.createRef();

        this.warehouseIndentUrl = INVENTORY_API_BASE_URL_2 + '/warehouse_indent';
        this.detailUrl = INVENTORY_API_BASE_URL_2 + '/warehouse_indent/detail';
        this.commentUrl = INVENTORY_API_BASE_URL_2 + '/warehouse_indent/comment';
        this.itemUrl = INVENTORY_API_BASE_URL_2 + '/item';
        this.itemRemarkEditUrl = INVENTORY_API_BASE_URL_2 + '/warehouse_indent/item_remark';
        this.warehouseIndentAnalysisUrl = INVENTORY_API_BASE_URL_2 + '/report/item-wise-warehouse-indent';
        
        // Modal refs
        this.cancelIndentModal = null;
        this.interchangebleItemModal = null;
        this.updateRemarkModal = null;
        this.indentDetailModalId = uuid();
    }

    componentDidMount() {
        // Only initialize modals if not rendering inline
        if (this.props.renderAs !== 'inline') {
            const modalElement = document.getElementById(this.indentDetailModalId);
            if (modalElement) {
                this.indentModal = new Modal(modalElement, { keyboard: false, backdrop: false });
            }
        }

        // Initialize modals
        setTimeout(() => {
            this.initializeModals();
        }, 100);

        if (this.props.transaction_id) {
            this.getIndentDetail(this.props.transaction_id);
        }
    }

    componentDidUpdate(prevProps) {
        const { transaction_id } = this.props;
        const { indentTransId, indent_loading, _loadingTransactionId } = this.state;

        if (transaction_id && 
            transaction_id !== prevProps.transaction_id && 
            transaction_id !== indentTransId &&
            !indent_loading &&
            _loadingTransactionId !== transaction_id) {
            this.getIndentDetail(transaction_id);
        }
    }

    initializeModals = () => {
        const cancelModal = document.getElementById('cancelIndentModal');
        const interchangeModal = document.getElementById('interchangebleItemModal');
        const remarkModal = document.getElementById('indentRemarkForm');

        if (cancelModal && !this.cancelIndentModal) {
            this.cancelIndentModal = new Modal(cancelModal, { keyboard: false, backdrop: false });
        }
        if (interchangeModal && !this.interchangebleItemModal) {
            this.interchangebleItemModal = new Modal(interchangeModal, { keyboard: false, backdrop: false });
        }
        if (remarkModal && !this.updateRemarkModal) {
            this.updateRemarkModal = new Modal(remarkModal, { keyboard: false, backdrop: false });
        }
    }

    modalIndentInit = (transaction_id) => {
        if (this.indentModal) {
            this.indentModal.show();
        }
        this.getIndentDetail(transaction_id);
    }

    getIndentDetail = (transaction_id, forceRefresh = false) => {
        if (!forceRefresh && this.state.indentTransId === transaction_id && this.state.indentDetail) {
            return;
        }

        if (this.state.indent_loading || this.state._loadingTransactionId === transaction_id) {
            return;
        }

        this.setState({ 
            indent_loading: true, 
            _loadingTransactionId: transaction_id 
        });

        HttpAPICall.withAthorization('GET', this.detailUrl + '/' + transaction_id, this.props.access_token, null, {}, (resp) => {
            let respData = resp.data;
            this.setState({
                indentDetail: respData.data,
                indentTransId: respData.data.transaction_id,
                allAllowedStatus: respData.data && respData.data.user_status && respData.data.user_status.length > 0 ? 
                    respData.data.user_status.map((s) => { return { value: s.id, label: s.name }; }) : [],
                addCommentForm: { ...this.updateCommentFormInit, status: respData.data.status_data ? respData.data.status_data.id : '' },
                indent_loading: false,
                _loadingTransactionId: null,
            }, () => {
                // After state update, re-initialize modals
                setTimeout(() => {
                    this.initializeModals();
                }, 100);
            });
            if (this.props.onDetailLoaded) {
                this.props.onDetailLoaded(respData.data);
            }
        }).catch(() => {
            this.setState({ 
                indent_loading: false, 
                _loadingTransactionId: null 
            });
        });
    }

    refreshDetail = (transaction_id) => {
        if (transaction_id) {
            this.getIndentDetail(transaction_id, true);
        } else if (this.state.indentTransId) {
            this.getIndentDetail(this.state.indentTransId, true);
        }
    }

    // Scroll to comment section
    scrollToComment = () => {
        if (this.commentRef.current) {
            this.commentRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }

    // Update Status
    submitUpdateCommentForm = (e) => {
        e.preventDefault();
        this.setState({ addCommentFormSubmitting: true });
        let frmData = {
            ...this.state.addCommentForm,
            transaction_id: this.state.indentTransId
        };
        HttpAPICall.withAthorization('PUT', this.commentUrl, this.props.access_token, {}, { ...frmData }, (response) => {
            toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
            this.getIndentDetail(this.state.indentTransId, true);
            if (this.state.indentDetail && this.state.indentDetail.status_data && this.state.indentDetail.status_data.id !== this.state.addCommentForm.status) {
                if (this.props.onUpdate) {
                    this.props.onUpdate();
                }
            }
            this.setState({ addCommentForm: { ...this.updateCommentFormInit } });
        }).then(() => this.setState({ addCommentFormSubmitting: false }));
    }

    // Download handlers
    downloadPdfHandler = (transaction_id) => {
        this.setState({ pdfDownloading: true });
        HttpAPICall.withAthorization('GET', this.detailUrl + '/' + transaction_id, this.props.access_token, { download: "download" }, {}, (response) => {
            download.file(response.data.file_path);
        }).then(() => this.setState({ pdfDownloading: false }));
    }

    downloadIndentAnalysisReportHandler = (transaction_id) => {
        this.setState({ indentAnalysisDownloading: true });
        let params = {
            action: "detail_download",
            search_same_wi_transaction_id: transaction_id
        };
        HttpAPICall.withAthorization('GET', this.warehouseIndentAnalysisUrl, this.props.access_token, params, {}, (response) => {
            download.file(response.data.file_path);
        }).then(() => this.setState({ indentAnalysisDownloading: false }));
    }

    // Edit
    editIndent = () => {
        if (this.state.indentDetail) {
            this.props.history.push({ 
                pathname: `/warehouse_indent_add`, 
                state: { indentDetailData: this.state.indentDetail } 
            });
        }
    }

    // Clone
    cloneIndent = () => {
        if (this.state.indentDetail) {
            this.props.history.push({ 
                pathname: `/warehouse_indent_add`, 
                state: { indentDetailData: this.state.indentDetail, clone: 'yes' } 
            });
        }
    }

    // Delete
    deleteIndent = (transaction_id) => {
        swal({
            title: "Delete",
            text: "This action cannot be reversed, Are you sure you want to proceed?",
            icon: "warning",
            buttons: ["No", "Yes"],
        }).then(willDelete => {
            if (willDelete) {
                HttpAPICall.withAthorization('DELETE', this.warehouseIndentUrl + '/delete/' + transaction_id, this.props.access_token, {}, {}, (response) => {
                    toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                    if (this.props.onDelete) {
                        this.props.onDelete();
                    }
                });
            }
        });
    }

    // Check all items
    checkAllItem = () => {
        let indentItemForCheckbox = document.getElementsByClassName('indent_item_id_checkbox');
        if (indentItemForCheckbox && indentItemForCheckbox.length > 0) {
            for (let i = 0; i < indentItemForCheckbox.length; i++) {
                indentItemForCheckbox[i].checked = document.getElementById('all_check_indent').checked;
            }
        }
    }

    // Indent Fulfillment from Voucher
    openIndentFulfillmentfromVoucher = () => {
        let indent_item_ids = [];
        let warehouse_ids = [];
        let status_levels = [];
        let pendingQtyList = [];
        let status_ids = [];
        let itemDataList = [];
        let transactionId = [];
        let indentDetail = this.state.indentDetail;

        let indentItemForCheckbox = document.getElementsByClassName('indent_item_id_checkbox');
        if (indentItemForCheckbox && indentItemForCheckbox.length > 0) {
            for (let i = 0; i < indentItemForCheckbox.length; i++) {
                if (indentItemForCheckbox[i].checked) {
                    indent_item_ids.push(indentItemForCheckbox[i].value);
                    warehouse_ids.push(indentItemForCheckbox[i].getAttribute("data-warehouseId"));
                    status_levels.push(indentItemForCheckbox[i].getAttribute("data-statusLevel"));
                    pendingQtyList.push(indentItemForCheckbox[i].getAttribute("data-pendingQty"));
                    status_ids.push(indentItemForCheckbox[i].getAttribute("data-statusIds"));
                    let selectedItemData = this.state?.indentDetail.items?.find(data => data?.itemData?.id == indentItemForCheckbox[i].value);
                    transactionId.push(indentItemForCheckbox[i].getAttribute("data-transactionId"));
                    itemDataList.push({ ...selectedItemData?.itemData, remark: selectedItemData && selectedItemData.remark ? selectedItemData.remark : '' });
                }
            }
        }
        let warehouse_ids_unique = warehouse_ids.filter((item, i, ar) => ar.indexOf(item) === i);
        if (indent_item_ids.length == 0) {
            toast.error('Please select atleast one Item', { position: toast.POSITION.TOP_RIGHT });
        } else if (warehouse_ids_unique.length > 1) {
            toast.error('Please select item with same warehouse', { position: toast.POSITION.TOP_RIGHT });
        } else if (pendingQtyList.includes('0')) {
            toast.error('Every item must have pending qty more than 0', { position: toast.POSITION.TOP_RIGHT });
        } else if (!status_levels.every((e) => e >= 3 && e < 5)) {
            toast.error('Fullfillment is allowed only for Approved Indents', { position: toast.POSITION.TOP_RIGHT });
        } else {
            let warehouseIndentData = {
                warehouse_id: warehouse_ids[0],
                items: indent_item_ids,
                status_ids: status_ids,
                transactionId: transactionId[0],
                assetProfile: indentDetail && indentDetail.assetProfile ? indentDetail.assetProfile : null,
                title: indentDetail && indentDetail.title ? indentDetail.title : '',
                itemDataList: itemDataList.map(v => ({ ...v, display_label: v.name, label: v.name, value: v.id }))
            };
            this.props.history.push({ 
                pathname: `/indent_fulfillment`, 
                state: { warehouseIndentData: warehouseIndentData } 
            });
        }
    }

    // Transfer Purchase
    transferPurchaseInit = () => {
        let indent_item_ids = [];
        let warehouse_ids = [];
        let status_levels = [];
        let purchaseQtyList = [];
        let status_ids = [];
        let transactionId = [];

        let indentItemForCheckbox = document.getElementsByClassName('indent_item_id_checkbox');
        if (indentItemForCheckbox && indentItemForCheckbox.length > 0) {
            for (let i = 0; i < indentItemForCheckbox.length; i++) {
                if (indentItemForCheckbox[i].checked) {
                    indent_item_ids.push(indentItemForCheckbox[i].value);
                    warehouse_ids.push(indentItemForCheckbox[i].getAttribute("data-warehouseId"));
                    status_levels.push(indentItemForCheckbox[i].getAttribute("data-statusLevel"));
                    purchaseQtyList.push(indentItemForCheckbox[i].getAttribute("data-purchaseQty"));
                    status_ids.push(indentItemForCheckbox[i].getAttribute("data-statusIds"));
                    transactionId.push(indentItemForCheckbox[i].getAttribute("data-transactionId"));
                }
            }
        }
        let warehouse_ids_unique = warehouse_ids.filter((item, i, ar) => ar.indexOf(item) === i);
        if (indent_item_ids.length == 0) {
            toast.error('Please select atleast one Item', { position: toast.POSITION.TOP_RIGHT });
        } else if (purchaseQtyList.includes('0')) {
            toast.error('Every item must have purchase qty more than 0', { position: toast.POSITION.TOP_RIGHT });
        } else if (!status_levels.every((e) => e >= 3 && e < 5)) {
            toast.error('Transfer Purchase is allowed only for Approved Indents', { position: toast.POSITION.TOP_RIGHT });
        } else {
            let warehouseIndentData = {
                warehouse_id: warehouse_ids[0],
                transactionId: transactionId[0],
            };
            this.props.history.push({ 
                pathname: `/inventory_transfer_list/add`, 
                state: { transferPurchaseFromIndent: warehouseIndentData } 
            });
        }
    }

    // Cancel Item
    cancelWarehouseIndentItem = () => {
        let cancelledItemList = [];
        let showErrorMessage = false;
        let indentItemForCheckbox = document.getElementsByClassName('indent_item_id_checkbox');
        if (indentItemForCheckbox && indentItemForCheckbox.length > 0) {
            for (let i = 0; i < indentItemForCheckbox.length; i++) {
                if (indentItemForCheckbox[i].checked) {
                    let itemId = indentItemForCheckbox[i].value;
                    let data = this.state.indentDetail.items.find(i => i.item_id == itemId);
                    let row = { ...cancelledItemList[i], ...data };
                    cancelledItemList[i] = row;
                }
            }
        }
        let list = cancelledItemList.filter(Boolean);
        if (list && list.length == 0 && !showErrorMessage) {
            toast.error('Please select an Item for Cancellation', { position: toast.POSITION.TOP_RIGHT });
        } else {
            // Ensure modal is initialized
            if (!this.cancelIndentModal) {
                this.initializeModals();
            }
            if (this.cancelIndentModal) {
                this.setState({
                    cancelledItemList: [...list],
                    cancelledItemForm: { ...this.cancelItemFormInit }
                }, () => {
                    this.cancelIndentModal.show();
                });
            } else {
                toast.error('Unable to open cancel modal', { position: toast.POSITION.TOP_RIGHT });
            }
        }
    }

    submitCancelItemForm = (e) => {
        e.preventDefault();
        let items = [...this.state.cancelledItemList];
        let itemsLists = items.map(i => {
            return { item_id: i.item_id, cancelled_qty: Number(i.new_cancelled_qty), transaction_id: i.transaction_id };
        });
        let formData = { ...this.state.cancelledItemForm, items: [...itemsLists] };

        this.setState({ cancelItemFormSubmitting: true });
        HttpAPICall.withAthorization('PUT', this.warehouseIndentUrl + '/item_cancel', this.props.access_token, {}, { ...formData }, (response) => {
            toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
            if (this.cancelIndentModal) {
                this.cancelIndentModal.hide();
            }
            this.setState({ cancelledItemForm: { ...this.cancelItemFormInit } });
            this.getIndentDetail(this.state.indentTransId, true);
           
        }).then(() => this.setState({ cancelItemFormSubmitting: false }));
    }

    // Interchange Item
    viewInterchangeableModalInit = (itemdata = null, key) => {
        if (!this.interchangebleItemModal) {
            this.initializeModals();
        }
        if (this.interchangebleItemModal) {
            this.interchangebleItemModal.show();
            this.setState({
                interchangeItemData: itemdata,
                interchangeItemForm: { notes: '' }
            }, () => this.getInterChangeableItemList(itemdata?.itemData?.id, 1));
        } else {
            toast.error('Unable to open interchange modal', { position: toast.POSITION.TOP_RIGHT });
        }
    }

    getInterChangeableItemList = (id, page = 1) => {
        this.setState({ interchangeable_loading: true, interchangeable_page: page, interchangeableItemList: [] });
        HttpAPICall.withAthorization('GET', this.itemUrl + '/interchangeable_item/' + id, this.props.access_token, {}, {}, (resp) => {
            let respData = resp.data;
            this.setState({
                interchangeableItemList: respData.data,
                interchangeableListingMeta: respData.meta,
                interchangeableTotalListingCount: respData.meta.total,
            });
        }).then(() => this.setState({ interchangeable_loading: false }));
    }

    checkAllInterchangeList = () => {
        let interchangeItemCheckboxCollections = document.getElementsByClassName('interchange_id_checkbox');
        if (interchangeItemCheckboxCollections && interchangeItemCheckboxCollections.length > 0) {
            for (let i = 0; i < interchangeItemCheckboxCollections.length; i++) {
                interchangeItemCheckboxCollections[i].checked = document.getElementById('all_check_interchange').checked;
            }
        }
    }

    submitSelectedInterchangeItem = (e) => {
        e.preventDefault();

        let interchangeItemCheckboxCollections = document.getElementsByClassName('interchange_id_checkbox');
        let allSelectedItems = [];
        let data = this.state.interchangeItemData ? this.state.interchangeItemData : null;
        let totalQty = 0;

        if (interchangeItemCheckboxCollections && interchangeItemCheckboxCollections.length > 0) {
            for (let i = 0; i < interchangeItemCheckboxCollections.length; i++) {
                if (interchangeItemCheckboxCollections[i].checked) {
                    let item_id = interchangeItemCheckboxCollections[i].value;
                    let qty = interchangeItemCheckboxCollections[i].getAttribute("data-qty");
                    allSelectedItems.push({ item_id: item_id, qty: qty });
                    totalQty += parseFloat(qty);
                }
            }
        }

        if (allSelectedItems.length == 0) {
            toast.error('Please select atleast one Item', { position: toast.POSITION.TOP_RIGHT });
        } else if (allSelectedItems.find(i => parseFloat(i.qty) <= 0)) {
            toast.error('Every Item\'s qty must be more than 0.', { position: toast.POSITION.TOP_RIGHT });
        } else if (allSelectedItems.find(i => i.qty == '' || i.qty == null)) {
            toast.error('Every Item\'s qty should not be blank', { position: toast.POSITION.TOP_RIGHT });
        } else if (totalQty > data.pending_qty) {
            toast.error('Total Qty cannot be more than pending Qty', { position: toast.POSITION.TOP_RIGHT });
        } else {
            let frmData = {
                transaction_id: data.transaction_id,
                item_id: data.itemData.id,
                replace_items: allSelectedItems,
                ...this.state.interchangeItemForm
            };
            this.setState({ saveInterchangeableItemForm: true });
            HttpAPICall.withAthorization('PUT', this.warehouseIndentUrl + '/item_change', this.props.access_token, {}, { ...frmData }, (response) => {
                toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                if (this.interchangebleItemModal) {
                    this.interchangebleItemModal.hide();
                }
                this.getIndentDetail(data.transaction_id, true);
              
            }).then(() => this.setState({ saveInterchangeableItemForm: false }));
        }
    }

    // Update Remarks
    updateRemarkModalInit = (item) => {
        if (!this.updateRemarkModal) {
            this.initializeModals();
        }
        if (this.updateRemarkModal) {
            this.setState({ remarkItem: item }, () => {
                this.updateRemarkModal.show();
            });
        } else {
            toast.error('Unable to open remarks modal', { position: toast.POSITION.TOP_RIGHT });
        }
    }

    handleRemarkForm = (e) => {
        e.preventDefault();

        let { item_id: indent_item_id, transaction_id, remark } = this.state.remarkItem;
        let itemData = this.state.indentDetail.items.find(i => i.item_id == indent_item_id);
        if (!itemData) {
            toast.error('Item not found', { position: toast.POSITION.TOP_RIGHT });
        } else if (remark == itemData.remark) {
            if (this.updateRemarkModal) {
                this.updateRemarkModal.hide();
            }
        } else {
            this.setState({ remarkSubmitting: true });
            HttpAPICall.withAthorization('PUT', this.itemRemarkEditUrl, this.props.access_token, {}, { indent_item_id, transaction_id, remark }, (response) => {
                this.getIndentDetail(transaction_id, true);
                toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
               
            }).then(() => {
                if (this.updateRemarkModal) {
                    this.updateRemarkModal.hide();
                }
                this.setState({ remarkSubmitting: false });
            });
        }
    }

    // View methods
    viewItemModalInit = (item) => {
        if (item && this.itemDetailsRef.current) {
            this.itemDetailsRef.current.modalInit(item);
        }
    }

    viewItemWisePOInit = (itemData = null, warehouse_id = '', indent_transacton_id = '') => {
        if (this.itemWisePORef.current) {
            this.itemWisePORef.current.modalInit(itemData, '', indent_transacton_id);
        }
    }

    viewItemWiseReqInit = (itemData = null, warehouse_id = '', indent_transacton_id = '') => {
       
        if (this.itemWiseReqRef.current) {
            this.itemWiseReqRef.current.modalInit(itemData, '', indent_transacton_id);
        }
    }

    viewItemWisePurchaseInit = (itemData = null, warehouse_id = '', indent_transacton_id = '') => {
        if (this.itemWisePurchaseRef.current) {
            this.itemWisePurchaseRef.current.modalInit(itemData, '', indent_transacton_id);
        }
    }

    viewItemWiseTransferInit = (itemData = null, warehouse_id = '', indent_transacton_id = '') => {
        if (this.itemWiseTransferRef.current) {
            this.itemWiseTransferRef.current.modalInit(itemData, '', indent_transacton_id);
        }
    }

    viewHistoryModalInit = (data, defaultAction = 'pr_history', extraParams = {}) => {
        if (this.state.indentDetail && data && this.HistoryRef.current) {
            let indentDetail = this.state.indentDetail;
            this.HistoryRef.current.modalHistoryInit(data, {
                warehouse_id: indentDetail?.warehouse_id,
                warehouse_detail: indentDetail?.warehouse_detail,
                indent_transaction_id: indentDetail.transaction_id || '',
                defaultAction: defaultAction,
                historyTypes: [
                    { value: 'pr_history', label: 'PR History' },
                    { value: 'consumption', label: 'Consumption History' },
                    { value: 'transaction_ledger', label: 'Item Transaction Ledger' }
                ]
            });
        }
    }

    // Form handlers
    formInputHandler = (e, formName) => {
        this.setState({
            [formName]: {
                ...this.state[formName],
                [e.target.name]: e.target.value
            }
        });
    }

    tapSelectChange = (selectedOption, formName, fieldName) => {
        this.setState({
            [formName]: {
                ...this.state[formName],
                [fieldName]: selectedOption ? selectedOption.value : null
            }
        });
    }

    dynamicInputHandlerByKeyNameVal = (value, keyName, index, stateKey) => {
        const updatedList = [...this.state[stateKey]];
        updatedList[index] = { ...updatedList[index], [keyName]: value };
        this.setState({ [stateKey]: updatedList });
    }

    // Render Modals (always rendered)
    renderModals = () => {
        let indent = this.state.indentDetail;
        let data = this.state.interchangeItemData ? this.state.interchangeItemData : null;
        let max_qty = data && data.pending_qty ? data.pending_qty : 0;

        return (
            <Ax>
                {/* Cancel Item Modal */}
                <div className="modal fade" id="cancelIndentModal" tabIndex="-1">
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Cancel Item for: {this.state.indentTransId}</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => { this.setState({ cancelledItemList: [] }); }}></button>
                            </div>
                            <form onSubmit={this.submitCancelItemForm}>
                                <div className="modal-body">
                                    {this.state.cancel_item_loading ? <Loader />
                                        : <Ax>
                                            <table className="table table-bordered table-responsive bg-white">
                                                <thead className="table-secondary">
                                                    <tr className="text-end">
                                                        <th scope="col" style={{ width: "5%" }} className="text-center">S.No</th>
                                                        <th scope="col" style={{ width: "28%" }} className="text-start">Item Details</th>
                                                        <th scope="col" className="text-center" style={{ width: "8%" }}>Indent Qty</th>
                                                        <th scope="col" className="text-end" style={{ width: "8%" }}>Fullfilled</th>
                                                        <th scope="col" className="text-end" style={{ width: "8%" }}>Pur. Req</th>
                                                        <th scope="col" className="text-end" style={{ width: "8%" }}>PO</th>
                                                        <th scope="col" className="text-end" style={{ width: "8%" }}>Purchase</th>
                                                        <th scope="col" className="text-end" style={{ width: "8%" }}>In Transit</th>
                                                        <th scope="col" className="text-end" style={{ width: "8%" }}>Cancelled</th>
                                                        <th scope="col" className="text-end" style={{ width: "8%" }}>Pending</th>
                                                        <th scope="col" style={{ width: "9%" }}>New Cancelled</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.cancelledItemList.map((i, k) => {
                                                        return <tr className="text-end" key={k}>
                                                            <td className="text-center align-middle">{k + 1}</td>
                                                            <td className='text-start'>{i.itemData ? <div><span className="fw-bold">{i.itemData.name}</span><br />
                                                                <div className="form-text"><b>Code: </b>{i.itemData.item_code}</div>
                                                                <div className="form-text"><b>Mfr: </b>{i.itemData?.manufacturer?.name ?? '-'} (MPN: {i.itemData?.manufacturer_part_no ?? "-"})</div>
                                                                <div className="form-text">{
                                                                    i.itemData?.tags?.length > 0 ?
                                                                        (i.itemData?.tags.map((item, idx) => <span key={idx} className="badge bg-secondary">{item.name}</span>))
                                                                        : '-'
                                                                }</div>
                                                                <div className="form-text"><b>Remark: </b>{i.remark ?? "-"}</div>
                                                            </div>
                                                                : null}</td>
                                                            <td>{i.indent_qty ? i.indent_qty : 0}</td>
                                                            <td>{i.fullfilled_qty ? i.fullfilled_qty : 0}</td>
                                                            <td>{i.req_qty ? i.req_qty : 0}</td>
                                                            <td>{i.po_qty ? i.po_qty : 0}</td>
                                                            <td>{i.purchase_qty ? i.purchase_qty : 0}</td>
                                                            <td>{i.transit_qty ? i.transit_qty : 0}</td>
                                                            <td>{i.cancelled_qty ? i.cancelled_qty : 0}</td>
                                                            <td>{i.pending_qty ? i.pending_qty : 0}</td>
                                                            <td className="text-end">
                                                                <TapInputNumber
                                                                    name="new_cancelled_qty"
                                                                    value={this.state.cancelledItemList[k]?.new_cancelled_qty}
                                                                    onChange={(newValue) => {
                                                                        const updatedRows = [...this.state.cancelledItemList];
                                                                        updatedRows[k].new_cancelled_qty = newValue;
                                                                        this.setState({ cancelledItemList: updatedRows });
                                                                    }}
                                                                    placeholder="Cancelled Qty"
                                                                    required={true}
                                                                    max={i.pending_qty}
                                                                />
                                                            </td>
                                                        </tr>
                                                    })}
                                                </tbody>
                                            </table>
                                            <div className="row align-items-center">
                                                <div className="col-sm-6">
                                                    <label htmlFor="notes" className="form-label">Notes</label>
                                                    <textarea
                                                        name="notes"
                                                        value={this.state.cancelledItemForm.notes}
                                                        onChange={(e) => this.formInputHandler(e, 'cancelledItemForm')}
                                                        className="form-control"
                                                        style={{ height: "100px" }}
                                                    />
                                                </div>
                                            </div>
                                        </Ax>}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" disabled={this.state.cancelItemFormSubmitting}
                                        onClick={() => { this.setState({ cancelledItemList: [] }); }}>Close</button>
                                    <button type="submit" className="btn btn-primary" disabled={this.state.cancelItemFormSubmitting}>Save</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                {/* Interchangeable Item Modal */}
                <div className="modal fade" id="interchangebleItemModal" tabIndex="-1">
                    <div className="modal-dialog modal-lg modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Interchange Item</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            {data && <div className='p-1 bg-light border-bottom'>
                                <table className='table table-sm mb-0 table-borderless text-sm'>
                                    <tbody>
                                        <tr>
                                            <td>Transaction ID</td>
                                            <th>{this.state.indentTransId}</th>
                                        </tr>
                                        <tr>
                                            <td style={{ width: "26%" }}>Item Name</td>
                                            <th>{data.itemData && data.itemData.name ? data.itemData.name : ""}</th>
                                        </tr>
                                        <tr>
                                            <td>Item Code</td>
                                            <th>{data.itemData && data.itemData.item_code ? data.itemData.item_code : "-"}</th>
                                        </tr>
                                        <tr>
                                            <td>Pending Qty</td>
                                            <th>{data && data.pending_qty ? data.pending_qty : '0'}</th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>}
                            <div className="modal-body">
                                <form className="bg-white" onSubmit={this.submitSelectedInterchangeItem} id="interchangeItemForm" method="post" encType="multipart/form-data">
                                    <table className="table table-hover table-bordered table-responsive bg-white my-3 table-sm">
                                        <thead className="table-secondary">
                                            <tr className="text-center">
                                                <th style={{ "width": '7%' }}>
                                                    <input type='checkbox' onChange={this.checkAllInterchangeList} id="all_check_interchange" />
                                                </th>
                                                <th className="text-start">Item Details</th>
                                                <th style={{ width: "13%" }} className="text-end">Qty</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.interchangeable_loading ?
                                                (<tr><td colSpan="6"><Loader /></td></tr>)
                                                : (this.state.interchangeableItemList && this.state.interchangeableItemList.length > 0 ?
                                                    (this.state.interchangeableItemList.map((item, k) => {
                                                        return (<tr key={k} className="text-center">
                                                            <td>
                                                                <input type='checkbox'
                                                                    className="interchange_id_checkbox"
                                                                    name="interchangebleItem"
                                                                    value={item.id}
                                                                    data-qty={item?.new_qty}
                                                                />
                                                            </td>
                                                            <td className="text-start"><Ax>
                                                                <b>{item.name}</b> <br />
                                                                <small>Code: <b>{item.item_code}</b></small> <br />
                                                                <small>Mfr: <b>{item.manufacturer?.name ?? '-'}</b> (MPN: <b>{item.manufacturer_part_no ?? '-'}</b>)</small>
                                                            </Ax></td>
                                                            <td>
                                                                <input
                                                                    className='form-control form-control-sm text-end'
                                                                    placeholder='Quantity'
                                                                    name="new_qty"
                                                                    type="number"
                                                                    value={item.new_qty}
                                                                    onChange={(e) => {
                                                                        this.state.interchangeableItemList[k] = { ...item, new_qty: e.target.value };
                                                                        this.dynamicInputHandlerByKeyNameVal(e.target.value, 'new_qty', k, 'interchangeableItemList');
                                                                    }}
                                                                    max={max_qty}
                                                                    autoComplete="off"
                                                                    step=".01"
                                                                />
                                                            </td>
                                                        </tr>);
                                                    }))
                                                    : (<tr><td colSpan="6" className="text-center">No Records</td></tr>)
                                                )
                                            }
                                        </tbody>
                                    </table>
                                    <div className="row align-items-center">
                                        <div className="col-sm-6">
                                            <label htmlFor="notes" className="form-label">Notes</label>
                                            <textarea
                                                name="notes"
                                                value={this.state.interchangeItemForm.notes}
                                                onChange={(e) => this.formInputHandler(e, 'interchangeItemForm')}
                                                className="form-control"
                                                autoComplete='off'
                                                style={{ height: "100px" }}
                                            />
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button type="submit" disabled={this.state.saveInterchangeableItemForm} className="btn btn-primary" form="interchangeItemForm">
                                    Submit {this.state.saveInterchangeableItemForm ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Update Remark Modal */}
                <div className="modal fade" id="indentRemarkForm" tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Update Remarks</h5>
                                <button
                                    disabled={this.state.remarkSubmitting}
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                ></button>
                            </div>
                            {this.state.remarkItem && <div className='p-1 bg-light border-bottom'>
                                <table className='table table-sm mb-0 table-borderless text-sm'>
                                    <tbody>
                                        <tr>
                                            <td style={{ width: "30%" }}>Item Indent ID</td>
                                            <th>{indent?.transaction_id}</th>
                                        </tr>
                                        <tr>
                                            <td style={{ width: "30%" }}>Item Name</td>
                                            <th>{this.state.remarkItem && this.state.remarkItem.itemData ? this.state.remarkItem.itemData.name : "-"}</th>
                                        </tr>
                                        <tr>
                                            <td style={{ width: "30%" }}>Item Code</td>
                                            <th>{this.state.remarkItem && this.state.remarkItem.itemData ? this.state.remarkItem.itemData.item_code : "-"}</th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>}
                            <div className="modal-body">
                                <form className="" id="indentRemark" onSubmit={this.handleRemarkForm}>
                                    <div className="row align-items-center">
                                        <div className="col-sm-12">
                                            <label htmlFor="notes" className="form-label">Remarks</label>
                                            <textarea
                                                name="Remarks"
                                                value={this.state.remarkItem && this.state.remarkItem.remark ? this.state.remarkItem.remark : ''}
                                                onChange={e => {
                                                    this.setState({ remarkItem: { ...this.state.remarkItem, remark: e.target.value } });
                                                }}
                                                className="form-control"
                                                autoComplete='off'
                                                style={{ height: "80px" }}
                                            />
                                        </div>
                                    </div>
                                </form>
                                <div className="modal-footer">
                                    <button disabled={this.state.remarkSubmitting} type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                    <button disabled={this.state.remarkSubmitting} type="submit" form='indentRemark' className="btn btn-primary">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Ax>
        );
    }

    // Render detail content
    renderDetailContent = () => {
        let indent = this.state.indentDetail;
        const { settings } = this.props;

        if (this.state.indent_loading) {
            return <Loader />;
        }

        if (!indent) {
            return <div className="text-center p-5">No indent selected</div>;
        }

        const indentForLabelMap = {
            asset: "Asset",
            workstation: "Workstation",
            employee: "Employee",
            vendor: "Vendor",
            customer: "Customer",
            sub_assembly: "Sub Assembly"
        };

        const indentForValueMap = {
            asset: indent?.assetProfile?.name,
            workstation: indent?.workstation?.workstation_name,
            employee: indent?.employee?.name,
            vendor: indent?.vendor?.name,
            customer: indent?.customer?.name,
            sub_assembly: indent?.subAssembly?.name
        };

        const indentForLabel = indentForLabelMap[indent?.indent_for] || "-";
        const indentForValue = indentForValueMap[indent?.indent_for] || "-";

        return (
            <div>
                <table className="table table-bordered bg-white">
                    <thead className="table-secondary">
                        <tr>
                            <th style={{ width: "33%" }}>ID</th>
                            <th style={{ width: "33%" }}>Date</th>
                            <th style={{ width: "33%" }}>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{indent.transaction_id ? indent.transaction_id : "-"}</td>
                            <td>{indent.transaction_date_display ? indent.transaction_date_display : "-"}</td>
                            <td className="align-middle">
                                {indent.status_data ? indent.status_data.name : ''}
                            </td>
                        </tr>
                    </tbody>
                </table>

                <table className="table table-hover table-bordered table-responsive bg-white mb-0">
                    <tbody>
                        <tr>
                            <td style={{ width: "33%" }}>Warehouse</td>
                            <td colSpan={2}>{indent.warehouse_detail ? <div><b>{indent.warehouse_detail.name} ({indent.warehouse_detail.code})</b> <br />
                                {indent.warehouse_detail ?
                                    <div className='pt-1'>Address: {indent.warehouse_detail.address1 ? indent.warehouse_detail.address1 + ", " : ""}
                                        {indent.warehouse_detail.address2 ? indent.warehouse_detail.address2 + ", " : ""}
                                        {indent.warehouse_detail.landmark ? indent.warehouse_detail.landmark + ", " : ""}
                                        {indent.warehouse_detail.city ? indent.warehouse_detail.city + ". " : "-"} <br />
                                        State: <b>{indent.warehouse_detail.state_name}</b> <br />
                                        GSTIN: {indent.warehouse_detail.gstin ? indent.warehouse_detail.gstin : "-"} <br />
                                    </div> : "-"}</div> : "-"} <br />
                            </td>
                        </tr>
                        <tr>
                            <td>Title</td>
                            <th>{indent.title ? indent.title : "-"}</th>
                        </tr>
                        <tr>
                            <td>Priority</td>
                            <td className='text-capitalize'>{indent.priority ?? "-"}</td>
                        </tr>
                        <tr>
                            <td>Due Date</td>
                            <td>{indent.due_date ? DateService.dateFormat(indent.due_date, 'DD-MMM-YYYY') : "-"}</td>
                        </tr>
                        <tr>
                            <td style={{ width: "33%" }}>Indent For</td>
                            <th>{indentForLabel}</th>
                        </tr>
                        {indent.indent_for && (
                            <tr>
                                <td style={{ width: "33%" }}>{indentForLabel}</td>
                                <th>{indentForValue}</th>
                            </tr>
                        )}
                        {settings && settings['ticket_warehouse_indent'] === "Y" &&
                            <tr>
                                <td style={{ width: "33%" }}>Ticket ID</td>
                                <th>{indent.ticket_id}</th>
                            </tr>
                        }
                        <tr>
                            <td>Tag Users</td>
                            <td>{indent && indent.usersList && indent.usersList.length > 0 ? indent.usersList.map(u => <div key={u.id}>{u.full_name}</div>) : ""}</td>
                        </tr>
                        {indent.additional_attributes_data && indent.additional_attributes_data.length > 0
                            ? indent.additional_attributes_data.map((attr) => {
                                return (<tr key={attr.key}>
                                    <td className='text-capitalize'>{attr.name ? attr.name : "-"}</td>
                                    <th>{attr.value ? attr.value : "-"}</th>
                                </tr>)
                            }) : null}
                    </tbody>
                </table>

                <table className="table table-sm table-bordered table-responsive table-fixed bg-white my-3" id="dataTable">
                    <thead className="table-secondary">
                        <tr className="text-end">
                            <th scope="col" style={{ width: "5%" }} className="text-center">
                                <input type='checkbox' onChange={this.checkAllItem} id="all_check_indent" />
                            </th>
                            <th scope="col" className="text-center" style={{ width: "31%" }}>Item Details</th>
                            <th scope="col" className="text-center" style={{ width: "8%" }}>Indent Qty</th>
                            <th scope="col" className="text-end" style={{ width: "8%" }}>Fullfilled</th>
                            <th scope="col" className="text-end" style={{ width: "8%" }}>Pur. Req</th>
                            <th scope="col" className="text-end" style={{ width: "8%" }}>PO</th>
                            <th scope="col" className="text-end" style={{ width: "8%" }}>Purchase</th>
                            <th scope="col" className="text-end" style={{ width: "8%" }}>In Transit</th>
                            <th scope="col" className="text-end" style={{ width: "8%" }}>Cancelled</th>
                            <th scope="col" className="text-end" style={{ width: "8%" }}>Pending</th>
                        </tr>
                    </thead>
                    <tbody>
                        {indent && indent?.items && indent?.items?.length > 0 ?
                            indent?.items?.map((i, k) => {
                                return (<tr key={k} className="text-end">
                                    <td className='text-center'>
                                        {k + 1} <br /><br />
                                        <input
                                            type='checkbox'
                                            name="foo"
                                            value={i?.itemData?.id}
                                            data-pendingQty={i.pending_qty}
                                            className="indent_item_id_checkbox"
                                            data-warehouseId={indent.warehouse_id}
                                            data-purchaseQty={i?.purchase_qty ?? 0}
                                            data-itemData={i?.itemData}
                                            data-transactionId={indent.transaction_id}
                                            data-statusLevel={indent.status_data && indent.status_data.level}
                                            data-statusIds={indent.status_data && indent.status_data.id}
                                        />
                                    </td>
                                    <td className="text-start">{i.itemData ? <div className='row'>
                                        <div className='col-sm-9'>
                                            <ItemViewInList item={i.itemData} remark={i.remark} viewItemModal={() => this.viewItemModalInit(i.itemData)} />
                                        </div>
                                        <div className='col-sm-3 text-end'>
                                            <tapIcon.imageIcon icon={tapIcon.ListActionIcon} alt="action-icon" className="img-fluid" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" />
                                            <ul className="dropdown-menu">
                                                <li className='dropdown-item' style={{ padding: "7px 5px" }} onClick={() => this.viewHistoryModalInit(i.itemData)}>
                                                    <button type="button" className='text-decoration-none btn btn-sm'>View History</button>
                                                </li>
                                                {this.props.permissions?.includes('isc-item-Interchangeable-edit') && 
                                                    <li><a href="#" className="dropdown-item" onClick={() => this.viewInterchangeableModalInit(i, k)}>Interchange Item</a></li>
                                                }
                                                <li><button className="dropdown-item" onClick={() => this.updateRemarkModalInit(i)}>Update Remarks</button></li>
                                            </ul>
                                        </div>
                                    </div> : null}</td>
                                    <td>
                                        {i.indent_qty ? i.indent_qty : 0}
                                        {i.itemData.measuring_unit?.name ? <span className="text-helping input-group-text text-end pr0">{i.itemData.measuring_unit?.name}</span> : null}
                                    </td>
                                    <td>{i.fullfilled_qty ? i.fullfilled_qty : 0}</td>
                                    <td onClick={() => this.viewItemWiseReqInit(i?.itemData, indent.warehouse_id, indent.transaction_id)} className='link-primary cursor_pointer'>{i.req_qty ? i.req_qty : 0}</td>
                                    <td onClick={() => this.viewItemWisePOInit(i?.itemData, indent.warehouse_id, indent.transaction_id)} className='link-primary cursor_pointer'>{i.po_qty ? i.po_qty : 0}</td>
                                    <td onClick={() => this.viewItemWisePurchaseInit(i?.itemData, indent.warehouse_id, indent.transaction_id)} className='link-primary cursor_pointer'>{i.purchase_qty ? i.purchase_qty : 0}</td>
                                    <td onClick={() => this.viewItemWiseTransferInit(i?.itemData, indent.warehouse_id, indent.transaction_id)} className='link-primary cursor_pointer'>{i.transit_qty ? i.transit_qty : 0}</td>
                                    <td>{i.cancelled_qty ? i.cancelled_qty : 0}</td>
                                    <td>{i.pending_qty ? i.pending_qty : 0}</td>
                                </tr>);
                            })
                            : <tr><td className='text-center' colSpan={10}>No Record</td></tr>
                        }
                    </tbody>
                </table>

                <div className="row align-items-center">
                    <div className="col-sm-6">
                        <label htmlFor="notes" className="form-label">Notes</label>
                        <div>{indent.notes ? indent.notes : "-"}</div>
                    </div>
                    <div className="col-sm-6">
                        <table className="table table-borderless">
                            <tbody>
                                <tr className="subtotal_bg_color">
                                    <th>Total Quantity</th>
                                    <td className='float-end'>{indent.total_qty ? indent.total_qty : 0}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <WarehouseIndentDocument indentDetails={indent} getIndentDetail={(id) => this.getIndentDetail(id)} />

                {/* Comments Section */}
                <div>
                    <div className="tab_content_wrapper" ref={this.commentRef}>
                        <span className="content_heading">Comments & History</span>
                    </div>
                    {this.state.allAllowedStatus ?
                        <form onSubmit={this.submitUpdateCommentForm}>
                            <div className="my-3 row">
                                <label className="col-sm-3 col-form-label">Change status to</label>
                                <div className="col-sm-5">
                                    <TapSelect
                                        changeEvent={(selectedOption) => {
                                            this.tapSelectChange(selectedOption, 'addCommentForm', 'status');
                                        }}
                                        value={this.state.allAllowedStatus.find(s => s.value == this.state.addCommentForm.status)}
                                        options={this.state.allAllowedStatus}
                                        isSearchable={false}
                                        isDisabled={indent.change_status == 'N' || !this.props.permissions?.includes('isc-warehouse-indent-status_change') ? true : false}
                                        placeholder="Please Select Status"
                                    />
                                </div>
                            </div>
                            <div className="my-2">
                                <label className="form-label">Comments</label>
                                <textarea
                                    name="notes"
                                    value={this.state.addCommentForm.notes}
                                    onChange={(e) => this.formInputHandler(e, 'addCommentForm')}
                                    className="form-control"
                                    placeholder="Please Add a comment"
                                    required
                                    style={{ height: "100px" }}
                                />
                            </div>
                            <div className="col-12 text-end">
                                <button type="submit" disabled={this.state.addCommentFormSubmitting} className="btn btn-primary mx-2">
                                    Update {this.state.addCommentFormSubmitting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin ms-2" />) : ''}
                                </button>
                            </div>
                        </form>
                        : null}
                </div>
                <hr />
                <div className="my-1">
                    {indent.comments && indent.comments.map((c, k) => {
                        return (<Ax key={k}>
                            <div className="row">
                                {c.msg ? <div className="col-sm-8" dangerouslySetInnerHTML={{ __html: c.msg.split("|").join("<br />") }} /> : <div className='col-sm-8'>-</div>}
                                <div className="col-sm-4 text-end">
                                    <tapIcon.imageIcon icon={tapIcon.CalenderIcon} className="img-fluid pr-5 fs12" alt="item-action" />
                                    <span> {c.created_at_display}</span>
                                </div>
                                <div className="col-sm-8 my-1">{c.notes}</div>
                            </div>
                            <hr />
                        </Ax>);
                    })}
                </div>
            </div>
        );
    }

    // Modal JSX (for modal mode)
    indentDetailModalJsx = () => {
        return (
            <div className="modal fade" id={this.indentDetailModalId} tabIndex="-1">
                <div className="modal-dialog modal-xl modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Indent Detail: {this.state.indentTransId ? this.state.indentTransId : "-"}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {this.renderDetailContent()}
                            {this.renderModals()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (this.props.renderAs === 'inline') {
            return (
                <div className="indent-detail-inline">
                    {this.renderDetailContent()}
                    {this.renderModals()}
                    <HistoryDataModal ref={this.HistoryRef} />
                    <ItemDetailsModal ref={this.itemDetailsRef} />
                    <POHistoryModal ref={this.itemWisePORef} />
                    <ReqHistoryItemWiseModal ref={this.itemWiseReqRef} />
                     <PurchaseItemWiseModal ref={this.itemWisePurchaseRef} />
                      <TransferItemWiseListModal ref={this.itemWiseTransferRef} /> 
                     {/* <PurchaseItemWiseModal ref={this.itemWisePurchaseRef} />
    <TransferItemWiseListModal ref={this.itemWiseTransferRef} />  */}
                   
                   
                </div>
            );
        }

        return (
            <div>
                {this.indentDetailModalJsx()}
                {this.renderModals()}
                 <HistoryDataModal ref={this.HistoryRef} />
                 <ItemDetailsModal ref={this.itemDetailsRef} />
                 <POHistoryModal ref={this.itemWisePORef} />
                 <ReqHistoryItemWiseModal ref={this.itemWiseReqRef} />
                  <PurchaseItemWiseModal ref={this.itemWisePurchaseRef} />
    <TransferItemWiseListModal ref={this.itemWiseTransferRef} />
                     
               
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        access_token: state.auth.access_token,
        isc_configuration: state.app && state.app.isc_configuration ? state.app.isc_configuration : null,
        settings: state.app.setting,
        permissions: state.app.acl_info && state.app.acl_info.permissions && state.app.acl_info.permissions.length > 0 ? 
            state.app.acl_info.permissions : []
    };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(IndentDetailModal);